/**
 * Clé publique (site key) Cloudflare Turnstile.
 *
 * Elle est publique par nature : elle peut rester dans le code.
 * Tant que cette valeur est vide, le CAPTCHA invisible est désactivé
 * et seules les protections anti-spam existantes s'appliquent
 * (honeypot, délai minimum, détection de texte aléatoire, limitation de fréquence).
 */
export const TURNSTILE_SITE_KEY = "0x4AAAAAAEKxs-GqnIedIbDA";

export const isTurnstileEnabled = () => TURNSTILE_SITE_KEY.trim().length > 0;
